// Guards the in-memory draft (DR-147): leaving the screen, switching project or reloading must not
// silently discard pending changes. Master Data drafts are never written to browser storage; the
// handover editor keeps its unsaved changes in the tab (DR-180) and says so in its question.

import { askConfirm } from '../ui/confirm';

let pendingCount = 0;
/** A screen's own question (for example when its changes are kept on the device). */
let pendingMessage: string | null = null;

/** Called by the units workspace whenever its number of pending rows changes. */
export function reportPendingChanges(count: number, message: string | null = null): void {
  pendingCount = count;
  pendingMessage = message;
}

/** True when changes are pending on the current screen. */
export const hasPendingChanges = (): boolean => pendingCount > 0;

/**
 * True when there is nothing to lose, or the user confirmed discarding the pending changes (the
 * application's own dialog). Resolves at once when nothing is pending.
 */
export function confirmDiscardPending(): Promise<boolean> {
  if (pendingCount === 0) return Promise.resolve(true);
  return askConfirm({
    title: 'לעזוב בלי לשמור?',
    message:
      pendingMessage ??
      (pendingCount === 1
        ? 'יש שינוי אחד שלא נשמר. אם תעזבו, הוא יבוטל.'
        : `יש ${String(pendingCount)} שינויים שלא נשמרו. אם תעזבו, הם יבוטלו.`),
    confirmLabel: 'לעזוב בלי לשמור',
    cancelLabel: 'להישאר',
    danger: true,
  });
}

/** Asks the browser to warn before a reload or tab close while changes are pending. */
export function warnOnUnload(event: BeforeUnloadEvent): void {
  if (pendingCount > 0) event.preventDefault();
}
